import StyledContainer from "style/styledContainer"
import styled from "styled-components"
import { ReactComponent as HotSvg } from 'assets/svgs/hot.svg'
import { ReactComponent as BalanceSvg } from 'assets/svgs/balance.svg'
import { RowCenter } from "style/preset"


export const TrendingTagCom = () => {
    return <TipBoxWrap $height="32px" $pl="8px" $pr="8px">
    <StyledContainer $fontSize="12px" $lineHeight="14px" $fontWeight6 $roobertSemiBold $color="#DF2935" $mr="8px">Trending</StyledContainer>
    <HotSvgWrap></HotSvgWrap>
</TipBoxWrap>
}

export const BalanceTagCom = () => {
    return  <TipBoxWrap $width="32px" $height="32px">
        <BalanceSvgWrap></BalanceSvgWrap>
    </TipBoxWrap>
}

const HotSvgWrap = styled(HotSvg)`
    widht: 20px;
    height: 20px;
`

const BalanceSvgWrap = styled(BalanceSvg)`
    width: 16px;
    height: 16px;
`

export const TipBoxWrap = styled(RowCenter)`
    background-color: #F6F5F4;
    border-radius: 12px;
`